import { Inject, Injectable, Optional, PLATFORM_ID } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { SharedService } from "./shared.service";
import { isPlatformBrowser } from "@angular/common";
import { SERVER_DATA } from "../tokens/server-data.token";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private config: any;

  constructor(
    private http: HttpClient, 
    private sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(SERVER_DATA) private serverData: any    
  ) {}


  async loadConfig(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http
        .get(this.sharedService.getDomainURL() + "/assets/config.json")
        .toPromise()
        .then((config) => {
          this.config = config;
        })
        .catch((error) => {
          console.error("Browser: Failed to load config.json", error);
          return Promise.resolve();
        });
      }else{
        this.config = this.serverData.config;
      }
  }


  get baseURL(): string {
    return this.config?.baseURL || "";
  }

  get googleMapKey(): string {
    return this.config?.googleMapKey || "";
  }

  get googleMapSecretKey(): string {
    return this.config?.googleMapSecretKey || "";
  }

  get recaptchaSiteKey(): string {
    return this.config?.recaptchaSiteKey || "";
  }
}
